(function () {

  var _controller = null;

  function init() {
    if (_controller) _controller.abort();
    _controller = new AbortController();
    var sig = { signal: _controller.signal };

    var wrapper = document.getElementById('contact-form-wrapper');
    var form    = wrapper ? wrapper.querySelector('form') : null;
    if (!form) return;

    var nameInput  = document.getElementById('contact-name');
    var emailInput = document.getElementById('contact-email');
    var msgInput   = document.getElementById('contact-message');
    var nameErr    = document.getElementById('contact-name-error');
    var emailErr   = document.getElementById('contact-email-error');
    var msgErr     = document.getElementById('contact-message-error');

    function setError(input, errEl, show) {
      if (!input || !errEl) return;
      if (show) {
        input.classList.add('is-error');
        errEl.hidden = false;
      } else {
        input.classList.remove('is-error');
        errEl.hidden = true;
      }
    }

    function validateEmail(val) {
      var at = val.indexOf('@');
      return at > 0 && val.indexOf('.', at) > at + 1;
    }

    function validate() {
      var nameVal  = nameInput  ? nameInput.value.trim()  : '';
      var emailVal = emailInput ? emailInput.value.trim() : '';
      var msgVal   = msgInput   ? msgInput.value.trim()   : '';

      var nameOk  = nameVal.length > 0;
      var emailOk = validateEmail(emailVal);
      var msgOk   = msgVal.length > 0;

      setError(nameInput,  nameErr,  !nameOk);
      setError(emailInput, emailErr, !emailOk);
      setError(msgInput,   msgErr,   !msgOk);

      return nameOk && emailOk && msgOk;
    }

    [nameInput, emailInput, msgInput].forEach(function(el) {
      if (!el) return;
      el.addEventListener('input', function() {
        el.classList.remove('is-error');
      }, sig);
    });

    /* Validate on submit; if invalid, prevent submission */
    form.addEventListener('submit', function(e) {
      if (!validate()) {
        e.preventDefault();
      }
      /* If valid, allow Shopify to handle the form submission */
    }, sig);
  }

  window.initContact = init;
  init();

})();
